import { useStore } from "@xyflow/react";
import { useCanvasApi } from "../context/CanvasContext";
import {
  useCanvasSelectionCount,
  useIsMultiSelectToolbarOpen,
} from "../context/CanvasSelectionCountContext";
import { isNodeLocked } from "../utils/nodeLock";

export function useNodeLocked(nodeId: string): boolean {
  return useStore((s) => isNodeLocked(s.nodeLookup.get(nodeId)));
}

/**
 * `canEdit` for one node: false while it is locked, so a locked node takes
 * the view-only path for its editor, resizer and toolbar. Using a widget or
 * block (vote, timer, interact mode) stays on the canvas-wide `canEdit`.
 */
export function useNodeCanEdit(nodeId: string): boolean {
  const { canEdit } = useCanvasApi();
  const locked = useNodeLocked(nodeId);
  return canEdit && !locked;
}

/** The Unlock toolbar stands in for a locked node's toolbar: sole selection, editors only. */
export function useShowUnlockToolbar(
  nodeId: string,
  selected: boolean | undefined,
  dragging: boolean | undefined,
): boolean {
  const { canEdit } = useCanvasApi();
  const locked = useNodeLocked(nodeId);
  const selectedNodeCount = useCanvasSelectionCount();
  const isMultiSelectToolbarOpen = useIsMultiSelectToolbarOpen();
  return (
    canEdit &&
    locked &&
    !!selected &&
    !dragging &&
    selectedNodeCount === 1 &&
    !isMultiSelectToolbarOpen
  );
}
